import { EnvType } from "../services";
import { IApiClient } from "../api-client";
import { GetMetadataFieldsListResponse } from "../Types/get-metadata-fields-list-response";
import { GetMetadataFieldEnumListsResponse } from "../Types/get-metadata-field-enum-lists-response";
import { DbMetadataFieldInfos } from "../Types/db-metadata-field-infos";
import { ChangeMetadataFieldSetupResponse } from "../Types/change-metadata-field-setup-response";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetAllMetadataViewInfoResponse } from "../Types/get-all-metadata-view-info-response";
import { GetMetadataViewEnumsResponse } from "../Types/get-metadata-view-enums-response";
import { DbMetadataViewInfos } from "../Types/db-metadata-view-infos";
import { GetBroadcasterEnumListsResponse } from "../Types/get-broadcaster-enum-lists-response";
import { DbDeliveryBroadcasterInfos } from "../Types/db-delivery-broadcaster-infos";
import { ChangeBroadcasterSetupResponse } from "../Types/change-broadcaster-setup-response";
import { GetCulturesResponse } from "../Types/get-cultures-response";
import { GetGraphsetDataResponse } from "../Types/get-graphset-data-response";
import { GraphsetType } from "../Types/graphset-type";
import { GetProviderEnumListsResponse } from "../Types/get-provider-enum-lists-response";
import { GetAllProvidersResponse } from "../Types/get-all-providers-response";
import { CreateProviderSetupFullRequest, CreateProviderSetupRequest } from "../Types/create-provider-setup-request";
import { ChangeProviderSetupResponse } from "../Types/change-provider-setup-response";
import { DbLabProviderInfos } from "../Types/db-lab-provider-infos";
import { GetSuperUserEnumsResponse } from "../Types/get-super-user-enums-response";
import { DumpDataRequest } from "../Types/dump-data-request";
import { DiffsDataResponse } from "../Types/diffs-data-response";
import { FirstUserRequest } from "../Types/first-user-request";
import { GetAgentsEnumsResponse } from "../Types/get-agents-enums-response";
import { ListPlatformsResponse } from "../Types/list-platforms-response";
import { GetFormatsResponse } from "../Types/get-formats-response";
import { GetFormatsEnumsResponse } from "../Types/get-formats-enums-response";
import { DbFormatInfos } from "../Types/db-format-infos";
import { DbFilePurgeRuleInfos } from "../Types/db-file-purge-rule-infos";
import { GetFilePurgeRulesResponse } from "../Types/get-file-purge-rules-response";
import { GetFilePurgeRulesEnumsResponse } from "../Types/get-file-purge-rules-enums-response";
import { GetJobsEnumsResponse } from "../Types/get-jobs-enums-response";
import { GetFileEnumListsResponse } from "../Types/get-file-enum-lists-response";
import { GetFileExtensionsListResponse } from "../Types/get-file-extensions-list-response";
import { GetStorageEnumListsResponse } from "../Types/get-storage-enum-lists-response";
import { GetAllStoragesResponse } from "../Types/get-all-storages-response";
import { GetStorageResponse } from "../Types/get-storage-response";
import { DbStorageInfos } from "../Types/db-storage-infos";
import { GetStatusTransitionsResponse } from "../Types/get-status-transitions-response";
import { DbStatusTransitionInfos } from "../Types/db-status-transition-infos";
import { GetWorkflowEnumsResponse } from "../Types/get-workflow-enums-response";
import { GetPlatformInfosEnumsResponse } from "../Types/get-platform-infos-enums-response";
import { GetPlatformInfosResponse } from "../Types/get-platform-infos-response";
import { DbPlatformInfos } from "../Types/db-platform-infos";
import { CopyPlatformRequest } from "../Types/copy-platform-request";
import { GetMarkerLanguagesResponse } from "../Types/get-marker-languages-response";
import { GetMarkerTranslationConfigResponse } from "../Types/get-marker-translation-config-response";
import { DbAssetMarkerFamilyInfos } from "../Types/db-asset-marker-family-infos";
import { GetQuotasListResponse } from "../Types/get-quotas-list-response";
import { DbQuotaInfos } from "../Types/db-quota-infos";
import { GetQuotaResponse } from "../Types/get-quota-response";
import { GetMetadataFieldsResponse } from "../Types/get-metadata-fields-response";
import { ListAgentsResponse } from "../Types/list-agents-response";
import { DbAssetMarkerTypeInfos } from "../Types/db-asset-marker-type-infos";
import { DbAgentInfos } from "../Types/db-agent-infos";
import { GetMarkerTypesByFamilyNameResponse } from "../Types/get-marker-types-by-family-name-response";
import { GetNamingRulesResponse } from "../Types/get-naming-rules-response";
import { DbMetadataNamingRuleInfos } from "../Types/db-metadata-naming-rule-infos";
import { UpdateNamingRuleResponse } from "../Types/update-naming-rule-response";
import { GetPlatformYtChannelsResponse } from "../Types/get-platform-yb-channels-response";
import { YoutubeChannel } from "../Types/youtube-channel";

interface ISetupApiClient {
  GetAllMetadataFields(): Promise<GetMetadataFieldsListResponse>;
  GetMetadataFieldsByBroadcasterId(broadcasterId: number): Promise<GetMetadataFieldsResponse>;
  GetMetadataFieldsByBroadcasterIdAndCultureId(
    broadcasterId: number,
    countryId: number
  ): Promise<GetMetadataFieldsResponse>;
  GetMetadataFieldsByBroadcasterIdAndCultureCode(
    broadcasterId: number,
    countryCode: string
  ): Promise<GetMetadataFieldsResponse>;
  GetMetadataFieldEnums(): Promise<GetMetadataFieldEnumListsResponse>;
  CreateMetadataField(field: DbMetadataFieldInfos): Promise<ChangeMetadataFieldSetupResponse>;
  UpdateMetadataField(field: DbMetadataFieldInfos): Promise<ChangeMetadataFieldSetupResponse>;
  DeleteMetadataField(id: number): Promise<GenericResponseStd>;
  GetAllMetadataViewsInfo(): Promise<GetAllMetadataViewInfoResponse>;
  GetMetadataViewEnumsInfo(): Promise<GetMetadataViewEnumsResponse>;
  CreateMetadataView(view: DbMetadataViewInfos): Promise<GenericResponseStd>;
  AddFolderFilterToMetadataView(id: number, folderId: number): Promise<GenericResponseStd>;
  UpdateMetadataView(view: DbMetadataViewInfos): Promise<GenericResponseStd>;
  DeleteMetadataView(id: number): Promise<GenericResponseStd>;
  GetBroadcasterEnums(): Promise<GetBroadcasterEnumListsResponse>;
  CreateBroadcaster(broadcaster: DbDeliveryBroadcasterInfos): Promise<ChangeBroadcasterSetupResponse>;
  UpdateBroadcaster(broadcaster: DbDeliveryBroadcasterInfos): Promise<ChangeBroadcasterSetupResponse>;
  DeleteBroadcaster(id: number): Promise<GenericResponseStd>;
  GetAllCultures(): Promise<GetCulturesResponse>;
  GetGraphsetData(graphsetType: GraphsetType): Promise<GetGraphsetDataResponse>;
  GetProviderEnums(): Promise<GetProviderEnumListsResponse>;
  GetAllProviders(): Promise<GetAllProvidersResponse>;
  CreateProvider(request: CreateProviderSetupRequest): Promise<ChangeProviderSetupResponse>;
  CreateProviderFull(request: CreateProviderSetupFullRequest): Promise<ChangeProviderSetupResponse>;
  UpdateProvider(request: DbLabProviderInfos): Promise<ChangeProviderSetupResponse>;
  DeleteProvider(providerId: number): Promise<GenericResponseStd>;
  GetSuperUserEnums(): Promise<GetSuperUserEnumsResponse>;
  DumpData(request: DumpDataRequest): Promise<GenericResponseStd>;
  Diffs(request: DumpDataRequest): Promise<DiffsDataResponse>;
  CreateFirstUser(request: FirstUserRequest): Promise<GenericResponseStd>;
  ListAgents(): Promise<ListAgentsResponse>;
  UpdateAgent(request: DbAgentInfos): Promise<GenericResponseStd>;
  GetAgentEnums(): Promise<GetAgentsEnumsResponse>;
  ListPlatforms(): Promise<ListPlatformsResponse>;
  GetFormats(): Promise<GetFormatsResponse>;
  GetFormatEnums(): Promise<GetFormatsEnumsResponse>;
  CreateFormat(request: DbFormatInfos): Promise<GenericResponseStd>;
  UpdateFormat(request: DbFormatInfos): Promise<GenericResponseStd>;
  DeleteFormat(id: number): Promise<GenericResponseStd>;
  CreateFilePurgeRule(rule: DbFilePurgeRuleInfos): Promise<GenericResponseStd>;
  UpdateFilePurgeRule(rule: DbFilePurgeRuleInfos): Promise<GenericResponseStd>;
  DeleteFilePurgeRule(id: number): Promise<GenericResponseStd>;
  GetFilePurgeRules(): Promise<GetFilePurgeRulesResponse>;
  GetFilePurgeRulesEnums(): Promise<GetFilePurgeRulesEnumsResponse>;
  GetJobsEnums(): Promise<GetJobsEnumsResponse>;
  GetFileEnums(): Promise<GetFileEnumListsResponse>;
  GetFileExtensions(): Promise<GetFileExtensionsListResponse>;
  GetStoragesEnums(): Promise<GetStorageEnumListsResponse>;
  GetAllStorages(): Promise<GetAllStoragesResponse>;
  GetExternalStorages(): Promise<GetAllStoragesResponse>;
  GetStorage(storageId: number): Promise<GetStorageResponse>;
  CreateStorage(storage: DbStorageInfos): Promise<GenericResponseStd>;
  UpdateStorage(storage: DbStorageInfos): Promise<GenericResponseStd>;
  GetStatusTransitions(): Promise<GetStatusTransitionsResponse>;
  UpdateStatusTransitions(request: DbStatusTransitionInfos[]): Promise<GenericResponseStd>;
  GetWorkflowEnums(): Promise<GetWorkflowEnumsResponse>;
  GetPlatformInfosEnums(): Promise<GetPlatformInfosEnumsResponse>;
  ReloadConfig(): Promise<GenericResponseStd>;
  GetPlatformInfos(): Promise<GetPlatformInfosResponse>;
  GetYtChannels(): Promise<GetPlatformYtChannelsResponse>;
  UpdatePlatformInfos(platform: DbPlatformInfos): Promise<GenericResponseStd>;
  CopyPlatform(request: CopyPlatformRequest): Promise<GenericResponseStd>;
  GetMarkerLanguages(): Promise<GetMarkerLanguagesResponse>;
  GetMarkerTranslationConfig(): Promise<GetMarkerTranslationConfigResponse>;
  GetMarkerTypesByFamilyName(familyName: string): Promise<GetMarkerTypesByFamilyNameResponse>;
  CreateMarkerFamily(request: DbAssetMarkerFamilyInfos): Promise<GenericResponseStd>;
  UpdateMarkerFamily(request: DbAssetMarkerFamilyInfos): Promise<GenericResponseStd>;
  DeleteMarkerFamily(id: number): Promise<GenericResponseStd>;
  CreateMarkerType(request: DbAssetMarkerTypeInfos): Promise<GenericResponseStd>;
  UpdateMarkerType(request: DbAssetMarkerTypeInfos): Promise<GenericResponseStd>;
  DeleteMarkerType(id: number): Promise<GenericResponseStd>;
  GetAllQuotasList(): Promise<GetQuotasListResponse>;
  CreateQuota(quota: DbQuotaInfos): Promise<GenericResponseStd>;
  UpdateQuota(request: DbQuotaInfos): Promise<GenericResponseStd>;
  DeleteQuota(id: number): Promise<GenericResponseStd>;
  GetQuota(id: number): Promise<GetQuotaResponse>;
}

export default class SetupApiClient implements ISetupApiClient {
  readonly servicePort = 9509;
  readonly serviceBaseUrl = "setup-service/api";

  setupApiClient: IApiClient;

  constructor(setupApiClient: IApiClient, envType: EnvType) {
    this.setupApiClient = setupApiClient;
    if (envType === "local") this.setupApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async GetAllMetadataFields(): Promise<GetMetadataFieldsListResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/metadata/fields`);
  }
  async GetMetadataFieldsByBroadcasterId(broadcasterId: number): Promise<GetMetadataFieldsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/metadata/fields/broadcaster/${broadcasterId}`);
  }
  async GetMetadataFieldsByBroadcasterIdAndCultureId(
    broadcasterId: number,
    countryId: number
  ): Promise<GetMetadataFieldsResponse> {
    return await this.setupApiClient.get(
      `${this.serviceBaseUrl}/metadata/fields/broadcaster/${broadcasterId}/${countryId}`
    );
  }
  async GetMetadataFieldsByBroadcasterIdAndCultureCode(
    broadcasterId: number,
    countryCode: string
  ): Promise<GetMetadataFieldsResponse> {
    return await this.setupApiClient.get(
      `${this.serviceBaseUrl}/metadata/fields/broadcaster/${broadcasterId}/${countryCode}`
    );
  }
  async GetMetadataFieldEnums(): Promise<GetMetadataFieldEnumListsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/metadata/field/enums`);
  }
  async CreateMetadataField(field: DbMetadataFieldInfos): Promise<ChangeMetadataFieldSetupResponse> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/metadata/field`, field);
  }
  async UpdateMetadataField(field: DbMetadataFieldInfos): Promise<ChangeMetadataFieldSetupResponse> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/metadata/field`, field);
  }
  async DeleteMetadataField(id: number): Promise<GenericResponseStd> {
    return await this.setupApiClient.delete(`${this.serviceBaseUrl}/metadata/field/${id}`);
  }
  async GetAllMetadataViewsInfo(): Promise<GetAllMetadataViewInfoResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/metadata/view`);
  }
  async GetMetadataViewEnumsInfo(): Promise<GetMetadataViewEnumsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/metadata/view/enums`);
  }
  async CreateMetadataView(view: DbMetadataViewInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/metadata/view`, view);
  }
  async AddFolderFilterToMetadataView(id: number, folderId: number): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/metadata/view/${id}/folder/${folderId}`);
  }
  async UpdateMetadataView(view: DbMetadataViewInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/metadata/view`, view);
  }
  async DeleteMetadataView(id: number): Promise<GenericResponseStd> {
    return await this.setupApiClient.delete(`${this.serviceBaseUrl}/metadata/view/${id}`);
  }
  async GetBroadcasterEnums(): Promise<GetBroadcasterEnumListsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/broadcaster/enums`);
  }
  async CreateBroadcaster(broadcaster: DbDeliveryBroadcasterInfos): Promise<ChangeBroadcasterSetupResponse> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/broadcaster`, broadcaster);
  }
  async UpdateBroadcaster(broadcaster: DbDeliveryBroadcasterInfos): Promise<ChangeBroadcasterSetupResponse> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/broadcaster`, broadcaster);
  }
  async DeleteBroadcaster(id: number): Promise<GenericResponseStd> {
    return await this.setupApiClient.delete(`${this.serviceBaseUrl}/broadcaster/${id}`);
  }
  async GetAllCultures(): Promise<GetCulturesResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/cultures`);
  }
  async GetGraphsetData(graphsetType: GraphsetType): Promise<GetGraphsetDataResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/data/graphset/${graphsetType}`);
  }
  async GetProviderEnums(): Promise<GetProviderEnumListsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/provider/enums`);
  }
  async GetAllProviders(): Promise<GetAllProvidersResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/provider`);
  }
  async CreateProvider(request: CreateProviderSetupRequest): Promise<ChangeProviderSetupResponse> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/provider`, request);
  }
  async CreateProviderFull(request: CreateProviderSetupFullRequest): Promise<ChangeProviderSetupResponse> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/provider-full`, request);
  }
  async UpdateProvider(request: DbLabProviderInfos): Promise<ChangeProviderSetupResponse> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/provider`, request);
  }
  async DeleteProvider(providerId: number): Promise<GenericResponseStd> {
    return await this.setupApiClient.delete(`${this.serviceBaseUrl}/provider/${providerId}`);
  }
  async GetSuperUserEnums(): Promise<GetSuperUserEnumsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/super-user/enums`);
  }
  async DumpData(request: DumpDataRequest): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/super-user/dump-data`, request);
  }
  async Diffs(request: DumpDataRequest): Promise<DiffsDataResponse> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/super-user/diffs`, request);
  }
  async CreateFirstUser(request: FirstUserRequest): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/super-user/first-user`, request);
  }
  async ListAgents(): Promise<ListAgentsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/agents`);
  }
  async UpdateAgent(request: DbAgentInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/agents`, request);
  }
  async GetAgentEnums(): Promise<GetAgentsEnumsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/agents/enums`);
  }
  async ListPlatforms(): Promise<ListPlatformsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/platforms`);
  }
  async GetFormats(): Promise<GetFormatsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/formats`);
  }
  async GetFormatEnums(): Promise<GetFormatsEnumsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/formats/enums`);
  }
  async CreateFormat(request: DbFormatInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/formats`, request);
  }
  async UpdateFormat(request: DbFormatInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/formats`, request);
  }
  async DeleteFormat(id: number): Promise<GenericResponseStd> {
    return await this.setupApiClient.delete(`${this.serviceBaseUrl}/format/${id}`);
  }
  async CreateFilePurgeRule(rule: DbFilePurgeRuleInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/purge-rules`, rule);
  }
  async UpdateFilePurgeRule(rule: DbFilePurgeRuleInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/purge-rules`, rule);
  }
  async DeleteFilePurgeRule(id: number): Promise<GenericResponseStd> {
    return await this.setupApiClient.delete(`${this.serviceBaseUrl}/purge-rules/${id}`);
  }
  async GetFilePurgeRules(): Promise<GetFilePurgeRulesResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/purge-rules`);
  }
  async GetFilePurgeRulesEnums(): Promise<GetFilePurgeRulesEnumsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/purge-rules/enums`);
  }
  async GetJobsEnums(): Promise<GetJobsEnumsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/jobs/enums`);
  }
  async GetFileEnums(): Promise<GetFileEnumListsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/files/enums`);
  }
  async GetFileExtensions(): Promise<GetFileExtensionsListResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/files/extensions`);
  }
  async GetStoragesEnums(): Promise<GetStorageEnumListsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/storages/enums`);
  }
  async GetAllStorages(): Promise<GetAllStoragesResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/storages`);
  }
  async GetExternalStorages(): Promise<GetAllStoragesResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/storages/external`);
  }
  async GetStorage(storageId: number): Promise<GetStorageResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/storages/${storageId}`);
  }
  async CreateStorage(storage: DbStorageInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/storages`, storage);
  }
  async UpdateStorage(storage: DbStorageInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/storages`, storage);
  }
  async GetStatusTransitions(): Promise<GetStatusTransitionsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/status-transitions`);
  }
  async UpdateStatusTransitions(request: DbStatusTransitionInfos[]): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/status-transitions`, request);
  }
  async GetWorkflowEnums(): Promise<GetWorkflowEnumsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/workflow/enums`);
  }
  async GetPlatformInfosEnums(): Promise<GetPlatformInfosEnumsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/config/enums`);
  }
  async ReloadConfig(): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/config/reload`);
  }
  async GetPlatformInfos(): Promise<GetPlatformInfosResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/config`);
  }
  async GetYtChannels(): Promise<GetPlatformYtChannelsResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/youtube-channels`);
  }
  async UpdatePlatformInfos(platform: DbPlatformInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/config`, platform);
  }
  async UpdateYoutubeChannelsInfos(ybChannels: YoutubeChannel[]): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/youtube-channels`, ybChannels);
  }
  async CopyPlatform(request: CopyPlatformRequest): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/platform`, request);
  }
  async GetMarkerLanguages(): Promise<GetMarkerLanguagesResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/marker/languages`);
  }
  async GetMarkerTranslationConfig(): Promise<GetMarkerTranslationConfigResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/marker/translation/config`);
  }
  async GetMarkerTypesByFamilyName(familyName: string): Promise<GetMarkerTypesByFamilyNameResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/marker/family/${familyName}/types`);
  }
  async CreateMarkerFamily(request: DbAssetMarkerFamilyInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/marker/family`, request);
  }
  async UpdateMarkerFamily(request: DbAssetMarkerFamilyInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/marker/family`, request);
  }
  async DeleteMarkerFamily(id: number): Promise<GenericResponseStd> {
    return await this.setupApiClient.delete(`${this.serviceBaseUrl}/marker/family/${id}`);
  }
  async CreateMarkerType(request: DbAssetMarkerTypeInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/marker/type`, request);
  }
  async UpdateMarkerType(request: DbAssetMarkerTypeInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/marker/type`, request);
  }
  async DeleteMarkerType(id: number): Promise<GenericResponseStd> {
    return await this.setupApiClient.delete(`${this.serviceBaseUrl}/marker/type/${id}`);
  }
  async GetAllQuotasList(): Promise<GetQuotasListResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/quotas-all`);
  }
  async CreateQuota(quota: DbQuotaInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/quota`, quota);
  }
  async UpdateQuota(request: DbQuotaInfos): Promise<GenericResponseStd> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/quota`, request);
  }
  async DeleteQuota(id: number): Promise<GenericResponseStd> {
    return await this.setupApiClient.delete(`${this.serviceBaseUrl}/quota/${id}`);
  }
  async GetQuota(id: number): Promise<GetQuotaResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/quota/${id}`);
  }
  async GetNamingRules(): Promise<GetNamingRulesResponse> {
    return await this.setupApiClient.get(`${this.serviceBaseUrl}/naming-rules`);
  }
  async UpdateNamingRule(namingRule: DbMetadataNamingRuleInfos): Promise<UpdateNamingRuleResponse> {
    return await this.setupApiClient.put(`${this.serviceBaseUrl}/naming-rules`, namingRule);
  }
  async CreateNamingRule(namingRule: DbMetadataNamingRuleInfos): Promise<UpdateNamingRuleResponse> {
    return await this.setupApiClient.post(`${this.serviceBaseUrl}/naming-rules`, namingRule);
  }
  async DeleteNamingRule(id: number): Promise<GetNamingRulesResponse> {
    return await this.setupApiClient.delete(`${this.serviceBaseUrl}/naming-rules/${id}`);
  }

  //------Utils------
  GetApiUrl(): string {
    return this.setupApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
